export default {
    showFilterPane(state){
        return state.showFilterPane;
    },
}